import { useCampaignPlannerContext } from '@/dashboards/CampaignPlanner/hooks/useCampaignPlannerContext';
import { Button } from '@analytical-alley/ui';
import { HiOutlineCalendar, HiPlus } from 'react-icons/hi';
import {
    ExplanationBanner,
    useExplanationBanner,
} from '@/dashboards/CampaignPlanner/components/ExplanationBanner';
import { useOptimizer } from '@/optimizer/hooks/useOptimizer';

export const EmptyState = () => {
    const { setShowSaveCampaignDialog } = useCampaignPlannerContext();
    const onCreateCampaign = () => {
        setShowSaveCampaignDialog(true);
    };
    const { medias: optimizerMedias } = useOptimizer();
    const {
        isVisible: isExplanationVisible,
        hide: hideExplanation,
    } = useExplanationBanner();
    const isReady = (optimizerMedias || []).length > 0;

    return (
        <div className="space-y-6">
            {isExplanationVisible && (
                <ExplanationBanner length={0} onClose={hideExplanation} />
            )}
            <div className="flex flex-col items-center justify-center py-20 px-8">
                <div className="flex flex-col items-center max-w-md text-center space-y-6">
                    <div className="w-20 h-20 rounded-full bg-linear-to-br from-blue-100 to-blue-50 flex items-center justify-center">
                        <HiOutlineCalendar className="w-10 h-10 text-blue-500" />
                    </div>
                    <div className="space-y-2">
                        <h3 className="text-2xl font-semibold">
                            No campaigns yet
                        </h3>
                        <p className="text-gray-500 text-base">
                            Start planning your campaigns to organize and
                            optimize your marketing efforts
                        </p>
                    </div>
                    <Button
                        color="blue"
                        size="lg"
                        onClick={onCreateCampaign}
                        className="mt-4"
                        disabled={!isReady}
                    >
                        <HiPlus className="mr-2 h-5 w-5" />
                        Create Your First Campaign
                    </Button>
                </div>
            </div>
        </div>
    );
};
